<script lang="ts">
	import { EnterOnView } from '$lib/actions/animations/EnterOnView';
	import type { ContentDescriptionLarge } from './DescriptionLargeQuery';

	let { data, theme = 'dark' }: { data: ContentDescriptionLarge; theme?: string } = $props();
</script>

<div class="container">
	<h3 class="text:description-small theme-{theme}" use:EnterOnView>
		{data.headline}
	</h3>
	<p class="text:bullit-large description theme-{theme}" use:EnterOnView={{ delay: 0.15 }}>
		{data.description}
	</p>
</div>

<style lang="scss">
	.container {
		display: flex;
		flex-direction: column;
	}

	.theme-light {
		color: hsl(var(--color-foreground));
	}

	.description {
		padding-top: 44px;
		color: hsl(var(--color-primary));

		&.theme-light {
			color: hsl(var(--color-foreground));
		}
	}
</style>
